var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();
var _isFever = true;
var _isOhmori = false;
var _isFirst = false;

//ローディング
import {loading} from "../include/module";
loading();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//SPヘッダーの開閉
import {spHeaderToggle} from "../include/module";
spHeaderToggle();

//YouTubeのモーダル
import {youtubeModal} from "../include/module";
youtubeModal();

//キービジュアル
const kvAnimeFever = (_time) => {

  const randomFever = Math.floor(Math.random() * Math.floor(2)) + 5;
  // const randomFever = 6;
  const $target = $('.idx-Keyvisual-' + randomFever);
  // const $target = $('.idx-Keyvisual-' + 4);
  $target.addClass('active');

  const $active = $('.active');
  setTimeout(function(){
    if($active.hasClass('idx-Keyvisual-5')){
      // ロゴ
      $('#idx-Keyvisual_Logo_fever').velocity({ scale:[1,.1] }, { delay:500, duration: 500, easing: 'easeOutBack', loop: false });
      // キャラ
      $('#idx-Keyvisual_Character-Vocal_fever').velocity({ opacity:[1,.0] }, { duration: 600, easing: 'linear', loop: false });
    }else if($active.hasClass('idx-Keyvisual-6')){
      if($active.hasClass('idx-Keyvisual-6')){
        // ロゴ
        $('#idx-Keyvisual_Logo_fever_02').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
        // キャラ
        $('#idx-Keyvisual_Character-Popipa_fever').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
        $('#idx-Keyvisual_Character-Afterglow_fever').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
        $('#idx-Keyvisual_Character-Pasupare_fever').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
        $('#idx-Keyvisual_Character-Harohapi_fever').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
        $('#idx-Keyvisual_Character-Roselia_fever').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
        $('#idx-Keyvisual_Character-Ras_fever').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
        $('#idx-Keyvisual_Character-Morfonica_fever').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      }
    }
  },_time);
  if($active.hasClass('idx-Keyvisual-5')){
    setTimeout(function(){
      $('#idx-Switch').addClass('active');
    },_time + 900);
  }else if($active.hasClass('idx-Keyvisual-6')){
    setTimeout(function(){
      $('#idx-Switch').addClass('active');
    },_time + 600);
  }

};

const kvAnimeOhmori = (_time) => {

  const randomOhmori = Math.floor(Math.random() * Math.floor(2)) + 3;
  const $target = $('.idx-Keyvisual-' + randomOhmori);
  // const $target = $('.idx-Keyvisual-' + 4);
  $target.addClass('active');

  const $active = $('.active');
  setTimeout(function(){
    if($active.hasClass('idx-Keyvisual-3')){
      // ロゴ
      $('#idx-Keyvisual_Logo_ohmori').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      // キャラ
      $('#idx-Keyvisual_Character-Popipa_ohmori').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      $('#idx-Keyvisual_Character-Afterglow_ohmori').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      $('#idx-Keyvisual_Character-Pasupare_ohmori').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      $('#idx-Keyvisual_Character-Harohapi_ohmori').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      $('#idx-Keyvisual_Character-Roselia_ohmori').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      $('#idx-Keyvisual_Character-Ras_ohmori').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      $('#idx-Keyvisual_Character-Morfonica_ohmori').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
    }else if($active.hasClass('idx-Keyvisual-4')){
      $active.addClass('animated');
    }
  },_time);
  if($active.hasClass('idx-Keyvisual-3')){
    setTimeout(function(){
      $('#idx-Switch').addClass('active');
    },_time + 600);
  }else if($active.hasClass('idx-Keyvisual-4')){
    setTimeout(function(){
      $('#idx-Switch').addClass('active');
    },_time + 1800);
  }

};

//キービジュアル第１期
const kvAnimeFirst = (_time) => {

  const random = Math.floor(Math.random() * Math.floor(2)) + 1;
  const $target = $('.idx-Keyvisual-' + random);
  // const $target = $('.idx-Keyvisual-' + 4);
  $target.addClass('active');

  const $active = $('.active');
  setTimeout(function(){
    if($active.hasClass('idx-Keyvisual-1')){
      // ロゴ
      $('#idx-Keyvisual_Logo').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      // キャラ
      $('#idx-Keyvisual_Character-Popipa').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      $('#idx-Keyvisual_Character-Afterglow').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      $('#idx-Keyvisual_Character-Pasupare').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      $('#idx-Keyvisual_Character-Harohapi').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
      $('#idx-Keyvisual_Character-Roselia').velocity({ scale:[1,.1] }, { duration: 600, easing: 'easeOutBack', loop: false });
    }else if($active.hasClass('idx-Keyvisual-2')){
      $active.addClass('animated');
    }
  },_time);
  if($active.hasClass('idx-Keyvisual-1')){
    setTimeout(function(){
      $('#idx-Switch').addClass('active');
    },_time + 600);
  }else if($active.hasClass('idx-Keyvisual-2')){
    setTimeout(function(){
      $('#idx-Switch').addClass('active');
    },_time + 1800);
  }
};

//切り替えボタン
const kvSwitch = () => {
  $('#idx-Switch').on('click', function(){
    if(_isFever) {
      $('.idx-Keyvisual').removeClass('active animated');
      $('.idx-Keyvisual_Character_Item,.idx-Keyvisual_Logo_Item').velocity({ scale:[0,.1] }, { duration: 0, easing: 'linear', loop: false });
      $('.idx-Keyvisual').velocity({ opacity:[1,.0] }, { duration: 600, easing: 'linear', loop: false });
      kvAnimeOhmori(600);
      $('#idx-Switch').removeClass().addClass('first');
      _isFever = false;
      _isOhmori = true;
      _isFirst = false;
    }else if(_isOhmori) {
      $('.idx-Keyvisual').removeClass('active animated');
      $('.idx-Keyvisual_Character_Item,.idx-Keyvisual_Logo_Item').velocity({ scale:[0,.1] }, { duration: 0, easing: 'linear', loop: false });
      $('.idx-Keyvisual').velocity({ opacity:[1,.0] }, { duration: 600, easing: 'linear', loop: false });
      kvAnimeFirst(600);
      $('#idx-Switch').removeClass().addClass('fever');
      _isFever = false;
      _isOhmori = false;
      _isFirst = true;
    }else if(_isFirst) {
      $('.idx-Keyvisual').removeClass('active animated');
      // $('.idx-Keyvisual_Character_Item,.idx-Keyvisual_Logo_Item').velocity({ scale:[0,.1] }, { duration: 0, easing: 'linear', loop: false });
      $('.idx-Keyvisual_Character-Vocal_fever').velocity({ opacity:0 }, { duration: 0, easing: 'linear', loop: false });
      kvAnimeFever(600);
      $('#idx-Switch').removeClass().addClass('ohmori');
      _isFever = true;
      _isOhmori = false;
      _isFirst = false;
    }
  });
};

window.addEventListener('load', () => {
  kvAnimeFever(1600);
  kvSwitch();
});



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js